import { CompSelectionProperty } from '../types.ts';
import { flagDuplicateAddresses, getCompSelectionMergeKey } from './compSelectionMatching.ts';

export const mergeSelectedComps = (
  recommendations: CompSelectionProperty[],
  comps: CompSelectionProperty[],
): CompSelectionProperty[] => {
  const seen = new Set<string>();
  const uniqueRecs = recommendations.filter((comp) => {
    const key = getCompSelectionMergeKey(comp);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  const uniqueComps = comps.filter((comp) => !seen.has(getCompSelectionMergeKey(comp)));

  return flagDuplicateAddresses([...uniqueRecs, ...uniqueComps]);
};
